import { render, staticRenderFns } from "./RuleConfig.vue?vue&type=template&id=15f4b000&scoped=true&"
import script from "./RuleConfig.vue?vue&type=script&lang=js&"
export * from "./RuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./RuleConfig.vue?vue&type=style&index=1&id=15f4b000&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4b000",
  null
  
)

export default component.exports